import { render, staticRenderFns } from "./userrecord.vue?vue&type=template&id=4037ff98&scoped=true&"
import script from "./userrecord.vue?vue&type=script&lang=js&"
export * from "./userrecord.vue?vue&type=script&lang=js&"
import style0 from "./userrecord.vue?vue&type=style&index=0&id=4037ff98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037ff98",
  null
  
)

export default component.exports